import { requests } from '@/libs/axios/axios'
import { LicenseEndpoints } from '../license-endpoints'
import { EditLicenseData } from '../license.interfaces'

async function editLicense(license: EditLicenseData, id: number) {
  return requests.put(`${LicenseEndpoints.LICENSE}/${id}`, license)
}

export default editLicense
